
    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import PageRequest from '@/store/entities/page-request'
    import { getLodop, demoDownloadPDF } from '@/common/js/LodopFuncs'
    import Enums from '@/lib/enums'
    import storeaddressInfo from '@/store/entities/back-storeaddress-list';
    import DateUtils from '@/common/js/DateUtils'
    import Preview from 'vue-photo-preview'
    import 'vue-photo-preview/dist/skin.css'
    import moment from 'moment'
    Vue.use(Preview);

    class BackStockAgeRecordRequest extends PageRequest {
        beginTime?: Date;
        endTime?: Date;
        storeId?: number;
        userCode: string;
        productNo: string;
    }

    @Component({
        name: "backstockagerecord",
        components: { }
    })
    export default class backstockproduct extends AbpBase {
        storeaddressList: Array<storeaddressInfo> = [];
        IsPublicList = Enums.getEnum(Enums.IsEffectiveStatus, true);
        pagerequest: BackStockAgeRecordRequest = new BackStockAgeRecordRequest();
        creationTime: Date[];
        get list() {
            return this.$store.state.backStockAgeRecord.list;
        };
        get loading() {
            return this.$store.state.backStockAgeRecord.loading;
        }
        pageChange(page: number) {
            this.$store.commit('backStockAgeRecord/setCurrentPage', page);
            this.getpage();
        }
        pagesizeChange(pagesize: number) {
            this.$store.commit('backStockAgeRecord/setPageSize', pagesize);
            this.getpage();
        }
        async searchPage() {
            this.$store.state.backStockAgeRecord.currentPage = 1;
            this.getpage();
        }
        async getpage() {

            this.pagerequest.maxResultCount = this.pageSize;
            this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
            //filters

            if (this.creationTime.length > 0) {
                this.pagerequest.beginTime = this.creationTime[0];
            }
            if (this.creationTime.length > 1) {
                this.pagerequest.endTime = this.creationTime[1];
            }
            await this.$store.dispatch({
                type: 'backStockAgeRecord/getAll',
                data: this.pagerequest
            })

        }
        async getData() {
            await this.$store.dispatch({
                type: 'backstoreaddress/getAll',
                data: {}
            })
            var a = new storeaddressInfo();
            a.id = null;
            a.storeName = "全部";
            this.storeaddressList = this.$store.state.backstoreaddress.list.filter(function (item) { return item.whetherEffective == true });
            if (this.storeaddressList.length == 1) {
                this.pagerequest.storeId = this.storeaddressList[0].id;
            }
            else {
                this.storeaddressList.push(a);
                this.pagerequest.storeId = null;
            }
        }
        get pageSize() {
            return this.$store.state.backStockAgeRecord.pageSize;
        }
        get totalCount() {
            return this.$store.state.backStockAgeRecord.totalCount;
        }
        get currentPage() {
            return this.$store.state.backStockAgeRecord.currentPage;
        }
        columns = [
            {
                title: '用户编码',
                key: 'userCode',
                width: 90,
            },
            {
                title: '产品编号',
                key: 'productNo',
                width: 180,
            },
            {
                title: '备货入库仓库',
                key: 'storeName',
                width: 120,
            },
            {
                title: '产品图片',
                key: 'productImgGuid',
                width: 95,
                render: (h: any, params: any) => {
                    if (params.row.productImgGuid) {
                        var data = { imageGuid: params.row.productImgGuid, url: null };
                        var url = "";
                        if (params.row.productImgGuid.indexOf("http") != -1) {
                            url = params.row.productImgGuid;
                        }
                        else {
                            this.$store.commit('expressuserinfo/getImgUrl', data);
                            url = data.url;
                        }
                        return h('img', {
                            style: {
                                width: "50px",
                                height: "50px",
                                verticalAlign: "middle"
                            },
                            attrs: {
                                src: url,
                                preview: "yc_" + params.row.id,
                                "preview-text": params.row.orderNumber + "cp"
                            }
                        });

                    } else {
                        return h('span', "");
                    }
                }
            },
            {
                title: '时间',
                width: 150,
                render: (h: any, params: any) => {
                    return h('div', (params.row.creationTime == null ? "" : DateUtils.formatLongDate(new Date(params.row.creationTime))))
                }
            },
            {
                title: '<=30',
                key: 'age1',
                width: 100,
            },
            {
                title: '<=60',
                key: 'age2',
                width: 100,
            },
            {
                title: '<=90',
                key: 'age3',
                width: 100,
            },
            {
                title: '<=120',
                key: 'age4',
                width: 100,
            },
            {
                title: '<=150',
                key: 'age5',
                width: 100,
            },
            {
                title: '>150',
                key: 'age6',
                width: 100,
            },
            {
                title: '产品Sku',
                key: 'productSku',
                width: 100,
            },
            {
                title: '商品名称',
                key: 'productName',
                width: 200,
            },
            {
                title: '体积',
                width: 150,
                render: (h: any, params: any) => {
                    return h('div', [h('h3', "长:" + (params.row.length ? params.row.length : "")), h('h3', "宽:" + (params.row.width ? params.row.width : "")), h('h3', "高:" + (params.row.height ? params.row.height : ""))])
                }
            },
            {
                title: '费用',
                width: 100,
                key: 'cost',
            },
        ]
        async created() {
            await this.getData();
            this.getpage();
        }
    }
